import React, { useEffect, useRef } from "react";
import "./App.css";
import { ErrorBoundary } from "./components/atoms/ErrorBoundary";

import Auth from "./components/pages/Auth/Auth";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useAppSelector } from "./Redux/Hooks";
import { usePermissions } from "./hooks/usePermissions";
import { getDefaultRouteForUser, getStoredStudioAccess } from "./Utils/permissionUtils";
import { MarketplaceLoadingSpinner } from "./components/organisms/Dashboard/Marketplace/MarketplaceEmptyState";
import { Provider } from "react-redux";
import store from "./Redux/Store";
import LoginForm from "./components/organisms/Auth/Login/LoginForm";
import OtplVerificationForm from "./components/organisms/Auth/OtpVerification/OtpVerificationForm";
import RegisterForm from "./components/organisms/Auth/Register/RegisterForm";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import HomePage from "./components/organisms/Dashboard/HomePage";
import SingleAlbum from "./components/organisms/Dashboard/SingleAlbumPage";
import AllMembersPage from "./components/organisms/Dashboard/AllMembersPage";
import CreateNewMemberPage from "./components/molecules/Dashboard/Member/CreateNewMember";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SubscriptionPage from "./components/organisms/Dashboard/SubscriptionPage";
import ShareCodePage from "./components/organisms/Dashboard/ShareCodePage";
import UpdateFolderPage from "./components/molecules/Dashboard/SingleAlbumPage/UpdateFolderPage";
import { setFCM, updateNotification } from "./Redux/Slice/Dashboard/ExtraSlice";
import EditMemberPage from "./components/molecules/Dashboard/Member/EditMember";
import EventCalendar from "./components/organisms/Dashboard/EventCalendar";
import { app, messaging } from "./firebase";
import { getToken, onMessage } from "firebase/messaging";
import { updateFCMTokenAPI } from "./Redux/ApiCalls/Auth/fcmToken";
import ChangePhoneNumber from "./components/organisms/Dashboard/ChangePhoneNumber";
import AllNotificationPage from "./components/organisms/Dashboard/AllNotificationPage";
import RedeemUser from "./components/atoms/Dashboard/HomePage/RedeemUser";
import ImageSalesPage from "./components/organisms/Dashboard/ImageSalesPage";
import AllPackagesPage from "./components/organisms/Dashboard/AllPackagesPage";
import AddNewPackagePage from "./components/molecules/Dashboard/Package/AddNewPackagePage";
import UserCreatedEvents from "./components/organisms/Dashboard/UserCreatedEvents";
import SubEventPage from "./components/molecules/Dashboard/UserEvents/SubEventPage";
import UserProfilePage from "./components/organisms/Dashboard/UserProfilePage";
import { fetchAllRemoteConfig } from "./Utils/RemoteConfig";
import AllCustomerTransactionPage from "./components/organisms/Dashboard/AllCustomerTransactionPage";
import { useLoadScript } from "@react-google-maps/api";
import CameraToCloudPage from "./components/organisms/Dashboard/CameraToCloud/CameraToCloudPage";
import PrivacyPolicy from "./components/pages/Extra/PrivacyPolicy";
import TermsCondition from "./components/pages/Extra/TermsAndCondition";
import AllQuotationPage from "./components/organisms/Dashboard/AllQuotationPage";
import SingleQuotationPage from "./components/organisms/Dashboard/SingleQuotationForm";
import WalletManagement from "./components/organisms/Dashboard/WalletManagement";
import { getWhiteLableObject, setHeadMeta } from "./config/whitelable";
import PaymentCompletePage from "./components/organisms/Dashboard/CustomerPaymentCompleteFlow";
import AlbumsPage from "./components/organisms/Dashboard/AlbumsPage";
import AnalyticsPage from "./components/organisms/Dashboard/AnalyticsPage";
import RefundAndRegister from "./components/pages/Extra/RefundAndRegister";
import PackagesRequest from "./components/organisms/Dashboard/PackagesRequest";
import PackagePaymentComplete from "./components/organisms/Dashboard/PackagePaymentComplete";
import StudioWebsitePage from "./components/organisms/Dashboard/StudioWebsitePage";
import PaymentsPage from "./components/organisms/Dashboard/PaymentsPage";
import WhatsAppDashboardPage from "./components/organisms/Dashboard/WhatsApp/WhatsAppDashboardPage";
import WhatsAppAccessGate from "./components/organisms/Dashboard/WhatsApp/WhatsAppAccessGate";
import ConversationsPage from "./components/organisms/Dashboard/WhatsApp/ConversationsPage";
import AutomationBuilderPage from "./components/organisms/Dashboard/WhatsApp/AutomationBuilderPage";
import CampaignManagerPage from "./components/organisms/Dashboard/WhatsApp/CampaignManagerPage";
import TemplateManagerPage from "./components/organisms/Dashboard/WhatsApp/TemplateManagerPage";
import BillingUsagePage from "./components/organisms/Dashboard/WhatsApp/BillingUsagePage";
import EventFormNew from "./components/pages/ShareCreateEventForm/EventForm1";
import DeeplinkRedirection from "./components/organisms/Dashboard/DeeplinkRedirection";
import { useClarityPageView } from "./analytics/useClarityPageView.ts";
import WhatsAppOnboardingPage from "./components/organisms/Dashboard/WhatsAppOnboardingPage";
import CashfreeRedirectCheckout from "./components/pages/Extra/CashfreeRedirectCheckout";
import CustomerPaymentPage from "./components/pages/Extra/CustomerPaymentPage";
import QuotationProductsPage from "./components/organisms/Dashboard/QuotationProductsPage";
import QuotationFixChargesPage from "./components/organisms/Dashboard/QuotationFixChargesPage";
import QuotationEventTypesPage from "./components/organisms/Dashboard/QuotationEventTypesPage";
import QuotationAlbumTypesPage from "./components/organisms/Dashboard/QuotationAlbumTypesPage";
import QuotationAlbumPapersPage from "./components/organisms/Dashboard/QuotationAlbumPapersPage";
import QuotationDashboardPage from "./components/organisms/Dashboard/QuotationDashboardPage";
import AllOrdersPage from "./components/organisms/Dashboard/AllOrdersPage";
import CreateOrderForm from "./components/organisms/Dashboard/CreateOrderFormPage";
import OrderWorkPage from"./components/organisms/Dashboard/OrderWorkPage";
import OrderTransactionPage from "./components/organisms/Dashboard/OrderTransactionPage";
import QuotationDetailsPage from "./components/organisms/Dashboard/QuotationDetailsPage";
import OrderDetailsPage from "./components/organisms/Dashboard/OrderDetailsPage";
import LeadsDashboardPage from "./components/organisms/Dashboard/Leads/LeadsDashboardPage";
import LeadDetailsPage from "./components/organisms/Dashboard/Leads/LeadDetailsPage";
import AllInvoicesPage from "./components/organisms/Dashboard/Invoice/AllInvoicesPage";
import InvoiceFormPage from "./components/organisms/Dashboard/Invoice/InvoiceFormPage";
import InvoiceDetailPage from "./components/organisms/Dashboard/Invoice/InvoiceDetailPage";
import EquipmentListPage from "./components/organisms/Dashboard/Equipment/EquipmentListPage";
import EquipmentFormPage from "./components/organisms/Dashboard/Equipment/EquipmentFormPage";
import EquipmentHistoryPage from "./components/organisms/Dashboard/Equipment/EquipmentHistoryPage";
import MarketplaceDashboardPage from "./components/organisms/Dashboard/Marketplace/MarketplaceDashboardPage";
import MarketplaceListingsPage from "./components/organisms/Dashboard/Marketplace/MarketplaceListingsPage";
import MarketplaceListingFormPage from "./components/organisms/Dashboard/Marketplace/MarketplaceListingFormPage";
import MarketplaceBookingsPage from "./components/organisms/Dashboard/Marketplace/MarketplaceBookingsPage";
import MarketplaceRequirementsPage from "./components/organisms/Dashboard/Marketplace/MarketplaceRequirementsPage";
import MarketplaceProfilePage from "./components/organisms/Dashboard/Marketplace/MarketplaceProfilePage";
import MarketplaceApplicationsPage from "./components/organisms/Dashboard/Marketplace/MarketplaceApplicationsPage";
import MarketplaceActivityPage from "./components/organisms/Dashboard/Marketplace/MarketplaceActivityPage";
import MarketplaceBrowsePage from "./components/pages/Marketplace/MarketplaceBrowsePage";
import MarketplaceTalentPage from "./components/pages/Marketplace/MarketplaceTalentPage";
import MarketplaceEquipmentPage from "./components/pages/Marketplace/MarketplaceEquipmentPage";
import MarketplaceListingDetailPage from "./components/pages/Marketplace/MarketplaceListingDetailPage";
import StudioCustomerDirectoryPage from "./components/organisms/Dashboard/CustomerDirectory/StudioCustomerDirectoryPage";

import MarketplaceMyOrdersPage from "./components/pages/Marketplace/MarketplaceMyOrdersPage";
import MarketplaceCreateProfilePage from "./components/pages/Marketplace/MarketplaceCreateProfilePage";
import MarketplaceAddListingPage from "./components/pages/Marketplace/MarketplaceAddListingPage";
import MarketplacePostRequirementPage from "./components/pages/Marketplace/MarketplacePostRequirementPage";
import MarketplaceMyListingsPage from "./components/pages/Marketplace/MarketplaceMyListingsPage";
import MarketplaceMyBookingsPage from "./components/pages/Marketplace/MarketplaceMyBookingsPage";
import MarketplaceMyProfilePage from "./components/pages/Marketplace/MarketplaceMyProfilePage";
import MarketplaceReceivedApplicationsPage from "./components/pages/Marketplace/MarketplaceReceivedApplicationsPage";
import InvoiceDashboardPage from "./components/organisms/Dashboard/Invoice/InvoiceDashboardPage";
import MarketplaceLayout from "./components/pages/Marketplace/MarketplaceLayout";
import MarketplaceTeamPage from "./components/pages/Marketplace/MarketplaceTeamPage";
import MarketplaceSavedPage from "./components/pages/Marketplace/MarketplaceSavedPage";
import MarketplaceHomeDashboardPage from "./components/pages/Marketplace/MarketplaceHomeDashboardPage";
import MarketplaceAgencyDirectoryPage from "./components/pages/Marketplace/MarketplaceAgencyDirectoryPage";
import MarketplaceAgencyDetailPage from "./components/pages/Marketplace/MarketplaceAgencyDetailPage";
import MarketplaceProjectQuotePage from "./components/pages/Marketplace/MarketplaceProjectQuotePage";
import MarketplaceAboutUsPage from "./components/pages/Marketplace/MarketplaceAboutUsPage";
import { isMarketplaceHost } from "./components/pages/Marketplace/MarketplaceShared";
import RoleManagementPage from "./components/organisms/Dashboard/RoleManagement/RoleManagementPage";
import PermissionRoute from "./components/atoms/Utlis/PermissionRoute";

const DashboardIndexRoute: React.FC = () => {
  const user = useAppSelector((state) => state.auth.user);
  const { isStudioOwner, hasModule, hasPermission, permissionsLoading, isSubUser } = usePermissions();

  if (permissionsLoading && isSubUser) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <MarketplaceLoadingSpinner padding="80px 20px" />
      </div>
    );
  }

  if (isStudioOwner || hasModule("DASHBOARD") || hasPermission("dashboard.view")) {
    return <AnalyticsPage />;
  }

  const storedAccess = getStoredStudioAccess();
  const target = getDefaultRouteForUser(storedAccess, user?.role);
  if (target === "/auth/login") {
    return <Navigate to="/auth/login" replace />;
  }
  const fallback = target === "/dashboard" || target === "/dashboard/" ? "/dashboard/albums/all" : target;
  return <Navigate to={fallback} replace />;
};

// Marketplace Team page added
function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navigate = useNavigate();
  useClarityPageView();
  onMessage(messaging, (payload) => {
    store.dispatch(updateNotification({ update: true, count: 1 }));
  });
  useEffect(() => {
    async function initializePushNotifications() {
      if (!("serviceWorker" in navigator) || !navigator.serviceWorker) {
        console.warn("Service Worker is not supported in this browser");
        return;
      }

      try {
        // First, register the service worker
        await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        console.log("Service Worker registered");

        // Wait for the service worker to be ready (active)
        const registration = await navigator.serviceWorker.ready;
        console.log("Service Worker is ready");

        // Now request push token after service worker is active
        const permission = await Notification.requestPermission();
        console.log("permission", permission);

        if (permission === "granted") {
          const token = await getToken(messaging, {
            vapidKey:
              "BLlRcimfpiB0wFXdmp2OGVHx5hGyMOjgke1yNtpokahKnMRmpbR-u5brlcoEUyGlHbrci-AdBqSku1GosO6X6yg",
            serviceWorkerRegistration: registration,
          });
          console.log("token", token);
          if (token) {
            store.dispatch(setFCM(token));
            // The useEffect below will handle calling the API when both tokens are available
          }
        } else if (permission === "denied") {
          console.warn("Notification permission denied");
        }

        // Listen for messages from the service worker
        navigator.serviceWorker.addEventListener("message", (event) => {
          if (event.data && event.data.msg === "backgroundMessage") {
            const payload = event.data.data;
            store.dispatch(updateNotification({ update: true, count: 1 }));
          }
        });
      } catch (err) {
        console.error("Service Worker registration or token request failed:", err);
      }
    }

    initializePushNotifications();
  }, []);
  useEffect(() => {
    const isMarketplace = isMarketplaceHost();
    setHeadMeta({
      title: isMarketplace ? "KwikMemories Marketplace" : `Dashboard - ${getWhiteLableObject().name}`,
      favicon: `/logos/${getWhiteLableObject().logo.filename}`,
      appleTouchIcon: `/logos/${getWhiteLableObject().logo.filename}`,
    });
  }, []);

  // Track if FCM token API call has been made to prevent duplicate calls
  const fcmTokenSentRef = useRef<string | null>(null);
  const isApiCallInProgressRef = useRef<boolean>(false);

  // Function to update FCM token on backend
  const updateFCMTokenOnBackend = async (fcmToken: string) => {
    // Prevent duplicate calls for the same token or concurrent calls
    if (fcmTokenSentRef.current === fcmToken || isApiCallInProgressRef.current) {
      return;
    }

    const accessToken = store.getState().auth.access_token || localStorage.getItem("access_token");

    // Only make API call if auth token is available
    if (!accessToken) {
      return;
    }

    isApiCallInProgressRef.current = true;
    try {
      await updateFCMTokenAPI(fcmToken);
      console.log("FCM token updated successfully");
      fcmTokenSentRef.current = fcmToken;
    } catch (error) {
      console.error("Failed to update FCM token:", error);
      // Reset on error so we can retry later
      fcmTokenSentRef.current = null;
    } finally {
      isApiCallInProgressRef.current = false;
    }
  };

  // Monitor store for FCM token and auth token changes, but only call API once
  useEffect(() => {
    let previousFcmToken: string | null | undefined = null;
    let previousAuthToken: string | null = null;

    const checkAndUpdate = () => {
      const state = store.getState();
      const currentFcmToken = state.extra.fcm_token;
      const currentAuthToken = state.auth.access_token || localStorage.getItem("access_token");

      // Only proceed if tokens have changed and both are available
      const fcmChanged = currentFcmToken !== previousFcmToken;
      const authChanged = currentAuthToken !== previousAuthToken;

      if ((fcmChanged || authChanged) && currentFcmToken && currentAuthToken) {
        updateFCMTokenOnBackend(currentFcmToken);
      }

      previousFcmToken = currentFcmToken;
      previousAuthToken = currentAuthToken;
    };

    // Check immediately
    checkAndUpdate();

    // Subscribe to store changes
    const unsubscribe = store.subscribe(checkAndUpdate);

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    fetchAllRemoteConfig();
    const path = location.pathname;
    const hasToken = !!localStorage.getItem("access_token");
    const isMarketplace = isMarketplaceHost();

    // 1. Support marketplace domain (marketplace.kwikmemories.com)
    if (isMarketplace) {
      if (path === "/marketplace" || path === "/marketplace/") {
        navigate("/", { replace: true });
        return;
      }
      if (path.startsWith("/marketplace/")) {
        navigate(path.replace(/^\/marketplace/, ""), { replace: true });
        return;
      }
      if (path.startsWith("/dashboard") || path.startsWith("/auth")) {
        navigate("/", { replace: true });
        return;
      }
      return;
    }

    // 2. Admin dashboard domain (admin.kwikmemories.com / localhost)
    // Allow public/share, extra, and marketplace routes without auth redirects
    const isPublicPath =
      path.startsWith("/share/form") ||
      path.startsWith("/extra") ||
      path.startsWith("/marketplace") ||
      path.startsWith("/equipment") ||
      path.startsWith("/talent") ||
      path.startsWith("/team") ||
      path.startsWith("/listing") ||
      path.startsWith("/item");

    if (isPublicPath) {
      return;
    }

    // If user is not authenticated, send them to login (except when already on auth routes)
    if (!hasToken) {
      if (!path.startsWith("/auth")) {
        navigate("/auth/login");
      }
      return;
    }

    // If user is authenticated and hits the root path, send them to dashboard index.
    // Otherwise, keep them on whatever nested route they are on (e.g. /dashboard/subscriptions).
    if (path === "/" || path === "") {
      navigate("/dashboard/");
    }
  }, []);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyDrb_5q1m_fYiBjtx53rYSZskDa6Ns5JNw",
    libraries: ["places"],
  });

  return (
    <Provider store={store}>
      <div className="App">
        <Routes>
          <Route path="/auth" element={<Auth />}>
            <Route path="otp" element={<OtplVerificationForm />} />
            <Route path="signup" element={<RegisterForm />} />
            <Route path="login" element={<LoginForm />} />
          </Route>
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<DashboardIndexRoute />} />
            <Route path="singleAlbum/:new" element={<SingleAlbum />} />
            <Route
              path="members/all"
              element={
                <PermissionRoute anyPermission={["members.read", "members.create", "members.update"]}>
                  <AllMembersPage />
                </PermissionRoute>
              }
            />
            <Route
              path="members/create/new"
              element={
                <PermissionRoute permission="members.create">
                  <CreateNewMemberPage />
                </PermissionRoute>
              }
            />
            <Route
              path="members/edit/:id"
              element={
                <PermissionRoute anyPermission={["members.read", "members.update"]}>
                  <EditMemberPage />
                </PermissionRoute>
              }
            />
            <Route path="albums/all" element={<AlbumsPage />} />
            {/* <Route path="analytics" element={<AnalyticsPage />} /> */}
            <Route path="albums/folder/:id" element={<UpdateFolderPage />} />
            <Route path="subscriptions" element={<SubscriptionPage />} />
            <Route
              path="albums/share/:code/:fullAccessCode"
              element={<ShareCodePage />}
            />
            <Route path="albums/redeemUsers/:id" element={<RedeemUser />} />
            <Route path="albums/image-sales/:id" element={<ImageSalesPage />} />
            <Route path="event" element={<EventCalendar />} />
            <Route path="events/userCreated" element={<UserCreatedEvents />} />
            <Route
              path="events/userCreated/single"
              element={<SubEventPage />}
            />

            <Route
              path="user/changePhoneNumber"
              element={<ChangePhoneNumber />}
            />
            <Route path="user/profile" element={<UserProfilePage />} />
            <Route path="customers/all" element={<StudioCustomerDirectoryPage />} />
            <Route path="customers" element={<StudioCustomerDirectoryPage />} />
            <Route path="user/customers" element={<StudioCustomerDirectoryPage />} />
            <Route
              path="user/allNotifications"
              element={<AllNotificationPage />}
            />
            <Route path="package/single" element={<AddNewPackagePage />} />
            <Route path="packages/all" element={<AllPackagesPage />} />
            <Route path="packages/request" element={<PackagesRequest />} />
            <Route
              path="user/transactions"
              element={<AllCustomerTransactionPage />}
            />
            {/* Roles & Permissions (RBAC) */}
            <Route
              path="roles"
              element={
                <PermissionRoute permission="role_management.read">
                  <RoleManagementPage />
                </PermissionRoute>
              }
            />
            <Route
              path="role-management"
              element={
                <PermissionRoute permission="role_management.read">
                  <RoleManagementPage />
                </PermissionRoute>
              }
            />

            <Route path="quotation/" element={<PermissionRoute permission="quotation.read"><AllQuotationPage /></PermissionRoute>} />
            <Route path="quotation/analytics" element={<PermissionRoute permission="quotation.read"><QuotationDashboardPage /></PermissionRoute>} />
            <Route
              path="quotation/products"
              element={<PermissionRoute permission="quotation.read"><QuotationProductsPage /></PermissionRoute>}
            />
            <Route
              path="quotation/fix-charges"
              element={<PermissionRoute permission="quotation.read"><QuotationFixChargesPage /></PermissionRoute>}
            />
            <Route
              path="quotation/event-types"
              element={<PermissionRoute permission="quotation.read"><QuotationEventTypesPage /></PermissionRoute>}
            />
            <Route
              path="quotation/album-types"
              element={<PermissionRoute permission="quotation.read"><QuotationAlbumTypesPage /></PermissionRoute>}
            />
            <Route
              path="quotation/album-papers"
              element={<PermissionRoute permission="quotation.read"><QuotationAlbumPapersPage/></PermissionRoute>}
            />
            <Route
              path="quotation/singleQuotation"
              element={<PermissionRoute permission="quotation.read"><SingleQuotationPage /></PermissionRoute>}
            />
            <Route
              path="quotation/view"
              element={<PermissionRoute permission="quotation.read"><QuotationDetailsPage /></PermissionRoute>}
            />
            <Route path="orders/create" element={<PermissionRoute permission="orders.create"><CreateOrderForm/></PermissionRoute>}/>
            <Route path="orders/all" element={<PermissionRoute permission="orders.read"><AllOrdersPage /></PermissionRoute>} />
            <Route path="orders" element={<PermissionRoute permission="orders.read"><AllOrdersPage /></PermissionRoute>} />
            <Route path="orders/work" element={<PermissionRoute permission="orders.read"><OrderWorkPage /></PermissionRoute>} />
            <Route path="orders/transactions" element={<PermissionRoute permission="orders.read"><OrderTransactionPage /></PermissionRoute>} />
            <Route path="orders/view" element={<PermissionRoute permission="orders.read"><OrderDetailsPage /></PermissionRoute>} />
            <Route path="wallet-management" element={<WalletManagement />} />
            <Route path="payments" element={<PermissionRoute permission="payments_management.read"><PaymentsPage /></PermissionRoute>} />
            <Route path="studio-website" element={<StudioWebsitePage />} />
            {/* WhatsApp CRM */}
            <Route path="whatsapp" element={<ErrorBoundary><WhatsAppDashboardPage /></ErrorBoundary>} />
            <Route
              path="whatsapp/conversations"
              element={
                <WhatsAppAccessGate>
                  <ConversationsPage />
                </WhatsAppAccessGate>
              }
            />
            <Route
              path="whatsapp/automation"
              element={
                <WhatsAppAccessGate>
                  <AutomationBuilderPage />
                </WhatsAppAccessGate>
              }
            />
            <Route
              path="whatsapp/campaigns"
              element={
                <WhatsAppAccessGate>
                  <CampaignManagerPage />
                </WhatsAppAccessGate>
              }
            />
            <Route
              path="whatsapp/templates"
              element={
                <WhatsAppAccessGate>
                  <TemplateManagerPage />
                </WhatsAppAccessGate>
              }
            />
            <Route
              path="whatsapp/billing"
              element={
                <WhatsAppAccessGate>
                  <BillingUsagePage />
                </WhatsAppAccessGate>
              }
            />
            <Route path="whatsapp-setup" element={<WhatsAppOnboardingPage />} />
            {/* Leads CRM */}
            <Route path="leads" element={<PermissionRoute permission="leads.read"><LeadsDashboardPage /></PermissionRoute>} />
            <Route path="leads/:id" element={<PermissionRoute permission="leads.read"><LeadDetailsPage /></PermissionRoute>} />
            {/* Camera to Cloud */}
            <Route path="camera-to-cloud" element={<PermissionRoute permission="camera_to_cloud.full"><CameraToCloudPage /></PermissionRoute>} />
            {/* Invoice Module */}
            <Route path="invoice" element={<PermissionRoute anyPermission={["invoice.read", "payments_management.read"]} module="INVOICE"><AllInvoicesPage /></PermissionRoute>} />
            <Route path="invoice/analytics" element={<PermissionRoute anyPermission={["invoice.read", "payments_management.read"]} module="INVOICE"><InvoiceDashboardPage /></PermissionRoute>} />
            <Route path="invoice/new" element={<PermissionRoute anyPermission={["invoice.create", "payments_management.create"]} module="INVOICE"><InvoiceFormPage /></PermissionRoute>} />
            <Route path="invoice/edit" element={<PermissionRoute anyPermission={["invoice.update", "payments_management.update"]} module="INVOICE"><InvoiceFormPage /></PermissionRoute>} />
            <Route path="invoice/view" element={<PermissionRoute anyPermission={["invoice.read", "payments_management.read"]} module="INVOICE"><InvoiceDetailPage /></PermissionRoute>} />
            {/* Equipment Management Module */}
            <Route path="equipment" element={<PermissionRoute permission="equipment.read"><EquipmentListPage /></PermissionRoute>} />
            <Route path="equipment/new" element={<PermissionRoute permission="equipment.create"><EquipmentFormPage /></PermissionRoute>} />
            <Route path="equipment/edit/:id" element={<PermissionRoute permission="equipment.update"><EquipmentFormPage /></PermissionRoute>} />
            <Route path="equipment/history" element={<PermissionRoute permission="equipment.read"><EquipmentHistoryPage /></PermissionRoute>} />
            <Route path="equipment/:id/history" element={<PermissionRoute permission="equipment.read"><EquipmentHistoryPage /></PermissionRoute>} />
            {/* Marketplace Module */}
            <Route path="marketplace" element={<MarketplaceDashboardPage />} />
            <Route path="marketplace/listings" element={<MarketplaceListingsPage />} />
            <Route path="marketplace/listings/new" element={<MarketplaceListingFormPage />} />
            <Route path="marketplace/listings/edit/:id" element={<MarketplaceListingFormPage />} />
            <Route path="marketplace/bookings" element={<MarketplaceBookingsPage />} />
            <Route path="marketplace/requirements" element={<MarketplaceRequirementsPage />} />
            <Route path="marketplace/profile" element={<MarketplaceProfilePage />} />
            <Route path="marketplace/applications" element={<MarketplaceApplicationsPage />} />
            <Route path="marketplace/activity" element={<MarketplaceActivityPage />} />
          </Route>
          <Route path="/share/form/:data" element={<EventFormNew />} />
          <Route
            path="/extra/payment/:token"
            element={<PaymentCompletePage />}
          />
          <Route
            path="/extra/deeplink"
            element={<DeeplinkRedirection />}
          />
          <Route
            path="/extra/booking-payment/:token"
            element={<PackagePaymentComplete />}
          />
          <Route path="/extra/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/extra/Terms-and-condition"
            element={<TermsCondition />}
          />
          <Route
            path="/extra/refund-register"
            element={<RefundAndRegister />}
          />
          <Route path="/extra/cashfree-redirect-checkout"
  element={<CashfreeRedirectCheckout />}
/>
          <Route
            path="/extra/customer-payment/:secret_token"
            element={<CustomerPaymentPage />}
          />

          {/* Public Marketplace */}
          <Route element={<MarketplaceLayout />}>
            <Route path="/marketplace" element={<MarketplaceBrowsePage />} />
            <Route path="/marketplace/dashboard" element={<MarketplaceHomeDashboardPage />} />
            <Route path="/marketplace/home-dashboard" element={<MarketplaceHomeDashboardPage />} />
            <Route path="/marketplace/equipment" element={<MarketplaceEquipmentPage />} />
            <Route path="/marketplace/talent" element={<MarketplaceTalentPage />} />
            <Route path="/marketplace/agency-directory" element={<MarketplaceAgencyDirectoryPage />} />
            <Route path="/marketplace/agencies" element={<MarketplaceAgencyDirectoryPage />} />
            <Route path="/marketplace/studios" element={<MarketplaceAgencyDirectoryPage />} />
            <Route path="/marketplace/agency/:id" element={<MarketplaceAgencyDetailPage />} />
            <Route path="/marketplace/project-quote" element={<MarketplaceProjectQuotePage />} />
            <Route path="/marketplace/about" element={<MarketplaceAboutUsPage />} />
            <Route path="/marketplace/team" element={<MarketplaceTeamPage />} />
            <Route path="/marketplace/listing/:id" element={<MarketplaceListingDetailPage />} />
            <Route path="/marketplace/item/:id" element={<MarketplaceListingDetailPage />} />
            <Route path="/marketplace/my-orders" element={<MarketplaceMyOrdersPage />} />
            <Route path="/marketplace/profile/create" element={<MarketplaceCreateProfilePage />} />
            <Route path="/marketplace/sell" element={<MarketplaceAddListingPage />} />
            <Route path="/marketplace/post-requirement" element={<MarketplacePostRequirementPage />} />
            <Route path="/marketplace/my-listings" element={<MarketplaceMyListingsPage />} />
            <Route path="/marketplace/my-bookings" element={<MarketplaceMyBookingsPage />} />
            <Route path="/marketplace/received-applications" element={<MarketplaceReceivedApplicationsPage />} />
            <Route path="/marketplace/profile" element={<MarketplaceMyProfilePage />} />
            <Route path="/marketplace/profile/:id" element={<MarketplaceMyProfilePage />} />
            <Route path="/marketplace/saved" element={<MarketplaceSavedPage />} />

            {/* Clean root routes for marketplace.kwikmemories.com domain */}
            <Route path="/" element={<MarketplaceBrowsePage />} />
            <Route path="/equipment" element={<MarketplaceEquipmentPage />} />
            <Route path="/talent" element={<MarketplaceTalentPage />} />
            <Route path="/team" element={<MarketplaceTeamPage />} />
            <Route path="/listing/:id" element={<MarketplaceListingDetailPage />} />
            <Route path="/item/:id" element={<MarketplaceListingDetailPage />} />
            <Route path="/my-orders" element={<MarketplaceMyOrdersPage />} />
            <Route path="/profile/create" element={<MarketplaceCreateProfilePage />} />
            <Route path="/sell" element={<MarketplaceAddListingPage />} />
            <Route path="/post-requirement" element={<MarketplacePostRequirementPage />} />
            <Route path="/my-listings" element={<MarketplaceMyListingsPage />} />
            <Route path="/my-bookings" element={<MarketplaceMyBookingsPage />} />
            <Route path="/received-applications" element={<MarketplaceReceivedApplicationsPage />} />
            <Route path="/profile" element={<MarketplaceMyProfilePage />} />
            <Route path="/profile/:id" element={<MarketplaceMyProfilePage />} />
            <Route path="/saved" element={<MarketplaceSavedPage />} />
          </Route>
        </Routes>
        <ToastContainer style={{ zIndex: 999999 }} />
        {/* <LanguageSwitcher /> */}
      </div>
    </Provider>
  );
}

export default App;
